import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/database';
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyA7Er4vBmX7fvCzKDkZB7Gmrt66QIs1NFc',
  authDomain: 'zimta-assurance.firebaseapp.com',
  projectId: 'zimta-assurance',
  storageBucket: 'zimta-assurance.appspot.com',
  messagingSenderId: '90284110267',
  appId: '1:90284110267:web:bc552a6c56ef4b11cb949e',
  measurementId: 'G-6HWXM8W68H'
};
// Initialize Firebase

// firebase.analytics();

export const firebaseStore = firebase.initializeApp(firebaseConfig);
